import CategoryGalleryFilterState from '@features/cms/components/categories/CategoryGalleryBlock/mobx/state/CategoryGalleryFilterState';
import { ICategoryFilterValue } from '@features/cms/components/categories/CategoryGalleryBlock/typescript';
class CategoryGalleryFiltrationState {
  public attributes: CategoryGalleryFilterState[];
  constructor(filters: CategoryGalleryFilterState[]) {
    this.attributes = filters;
  }
  getAttributesCount() {
    return this.attributes.length;
  }
  getValuesCount() {
    return this.attributes.reduce((acc, attribute) => acc + attribute.getValuesCount(), 0);
  }
  getValuesByAttributeCode = (attributeCode: string) => this.attributes.find(attribute => attribute.code === attributeCode)?.values || [];
  selectValue = (attributeCode: string, value: ICategoryFilterValue) => {
    const attribute = this.attributes.find(attr => attr.code === attributeCode);
    if (attribute) {
      attribute.addValue(value);
    }
  };
  deselectValue = (attributeCode: string, valueCode: string) => {
    const attribute = this.attributes.find(attr => attr.code === attributeCode);
    if (attribute) {
      attribute.removeValue(valueCode);
    }
  };
  deselectAllValuesForAttribute = (attributeCode: string) => {
    const attribute = this.attributes.find(attr => attr.code === attributeCode);
    if (attribute) {
      attribute.removeAllValues();
    }
  };
  deselectAllValues = () => {
    this.attributes.forEach(attribute => attribute.removeAllValues());
  };
  doesAttributeExist = (attributeCode: string) => this.attributes.some(attribute => attribute.code === attributeCode);
}
export default CategoryGalleryFiltrationState;